import { useTranslation } from "react-i18next"
import { BetterDocExchangeTable } from "@/modules/admin/better-doc/components/better-doc-exchange-table"
import { BetterDocSessionTable } from "@/modules/admin/better-doc/components/better-doc-session-table"
import { BetterDocLookupResult } from "@/modules/admin/better-doc/services/betterDocLookupQuery"

type BetterDocLookupResultsProps = {
  result: BetterDocLookupResult | null
}

export const BetterDocLookupResults = ({ result }: BetterDocLookupResultsProps) => {
  const { t } = useTranslation()

  if (result === null || (result.sessions.length === 0 && !result.exchange)) {
    return (
      <p className="text-on-surface-subdued text-sm" data-testid="better-doc-admin-lookup-empty">
        {t("admin.betterDoc.lookup.empty")}
      </p>
    )
  }

  const { sessions, exchange } = result

  return (
    <div className="flex flex-col gap-6" data-testid="better-doc-admin-lookup-results">
      {sessions.length === 0 ? null : (
        <section className="flex flex-col gap-2">
          <h3 className="text-on-surface text-base font-medium">{t("admin.betterDoc.lookup.sessions")}</h3>
          <BetterDocSessionTable sessions={sessions} />
        </section>
      )}
      {exchange ? (
        <section className="flex flex-col gap-2">
          <h3 className="text-on-surface text-base font-medium">{t("admin.betterDoc.lookup.exchange")}</h3>
          <BetterDocExchangeTable
            exchanges={[exchange]}
            emptyMessage={t("admin.betterDoc.exchangeTable.empty")}
            testId="better-doc-admin-lookup-exchange-table"
          />
        </section>
      ) : null}
    </div>
  )
}
